/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The UsersCreateBody model module.
 * @module model/UsersCreateBody
 * @version 1.0.0
 */
export class UsersCreateBody {
  /**
   * Constructs a new <code>UsersCreateBody</code>.
   * @alias module:model/UsersCreateBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UsersCreateBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UsersCreateBody} obj Optional instance to populate.
   * @return {module:model/UsersCreateBody} The populated <code>UsersCreateBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UsersCreateBody();
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('firstName'))
        obj.firstName = ApiClient.convertToType(data['firstName'], 'String');
      if (data.hasOwnProperty('lastName'))
        obj.lastName = ApiClient.convertToType(data['lastName'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} username
 */
UsersCreateBody.prototype.username = undefined;

/**
 * @member {String} password
 */
UsersCreateBody.prototype.password = undefined;

/**
 * @member {String} firstName
 */
UsersCreateBody.prototype.firstName = undefined;

/**
 * @member {String} lastName
 */
UsersCreateBody.prototype.lastName = undefined;

